export const PWA_UPDATE_EVENT = "ceo-os:update-available";
let registration: ServiceWorkerRegistration | undefined;

export function shouldOfferPWAUpdate(
  workerState: ServiceWorkerState,
  hasController: boolean,
): boolean {
  return workerState === "installed" && hasController;
}

function announceWaitingUpdate(): void {
  window.dispatchEvent(new CustomEvent(PWA_UPDATE_EVENT));
}

export function registerPWA(): void {
  if (!("serviceWorker" in navigator) || !import.meta.env.PROD) {
    return;
  }
  window.addEventListener("load", () => {
    void (async () => {
      const existing = await navigator.serviceWorker.getRegistration();
      return existing ?? navigator.serviceWorker.register("/sw.js");
    })().then((nextRegistration) => {
      registration = nextRegistration;
      if (nextRegistration.waiting && navigator.serviceWorker.controller) {
        announceWaitingUpdate();
      }
      nextRegistration.addEventListener("updatefound", () => {
        const worker = nextRegistration.installing;
        worker?.addEventListener("statechange", () => {
          if (shouldOfferPWAUpdate(worker.state, Boolean(navigator.serviceWorker.controller))) {
            announceWaitingUpdate();
          }
        });
      });
    });
  });
}

export async function checkForPWAUpdate(): Promise<void> {
  await registration?.update();
}

export async function hasWaitingPWAUpdate(): Promise<boolean> {
  const current = registration ?? (await navigator.serviceWorker?.getRegistration());
  if (current) registration = current;
  return Boolean(current?.waiting && navigator.serviceWorker.controller);
}

export function applyWaitingPWAUpdate(): boolean {
  const waiting = registration?.waiting;
  if (!waiting) return false;
  navigator.serviceWorker.addEventListener(
    "controllerchange",
    () => {
      window.location.reload();
    },
    { once: true },
  );
  waiting.postMessage({ type: "SKIP_WAITING" });
  return true;
}
